import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { ChartService } from 'src/app/shared/services/chart.service';
import { Observable, Observer } from 'rxjs';

@Component({
  selector: 'app-historical-sites',
  templateUrl: './historical-sites.component.html',
  styleUrls: ['./historical-sites.component.scss']
})
export class HistoricalSitesComponent implements OnInit, AfterViewInit {

  @Input() siteAbout = '';
  @Input() scoreCardObj: any = {};
  @Input() allImageData: any = [];

  aboutTextLess = `The Golden Temple is famous for its full golden dome, it is one of the most sacred pilgrim spots for sikhs. the mandir is built on a 67-ft square of marble and is a two storied structure. maharaja ranjit singh had the upper half of the building built with approximately 400 kg of gold leaf. The golden temple is surrounded by a number of other famous temples like the durgiana temple. the fourth guru of sikhs, guru ram das, who had initially constructed a pool here, founded amritsar, which houses the golden temple or harmandir sahib. It is here that sage valmiki wrote the epic, ramayana. rama and sita are believed to have spent their fourteen-year exile in amritsar, the epicenter`;
  aboutTextMore = `of sikhism. to the south of the temple is a garden, and the tower of baba atal. the central sikh museum is atop the clock tower.`;
  ratingCard = [
    {
      id: '1',
      name: 'Site Overall',
      percentScore: 'overall_score'
    },
    {
      id: '2',
      name: 'Accessibility',
      percentScore: 'overall_accessibility'
    },
    {
      id: '3',
      name: 'Amentities',
      percentScore: 'overall_amenities'
    },
    {
      id: '4',
      name: 'Hygiene',
      percentScore: 'overall_hygiene'
    },
    {
      id: '5',
      name: 'Safety & Security',
      percentScore: 'overall_safety'
    },
  ];
  ratingStatus = [
    {
      id: '1',
      path: '../../../assets/historical/emoji-laugh-black-icon-1.svg',
      name: 'Satisfactory (66% or above)'
    },
    {
      id: '2',
      path: '../../../assets/historical/confused-icon.svg',
      name: 'Moderate (34% to 65%)'
    },
    {
      id: '3',
      path: '../../../assets/historical/crying-black-icon.svg',
      name: 'Unsatisfactory (Below 33%)'
    },
  ];
  titles = ['About', 'Tourist Overall Perception'];
  readMore = 'Read More';
  tName = 'Golden Temple';

  id1 = 'barchartId1';
  id2 = 'barchartId2';
  type = 'bar';
  activeButton: any;
  data: any = {
    labels: ['Golden Temple', 'Spiritual Religious Avg.', 'State Avg.', 'National Avg.'],
    datasets: [{
      label: '',
      barThickness: 20,
      data: [4, 3, 3, 2.4],
      backgroundColor: 'blue',
      borderColor: 'blue',
      borderWidth: 1
    }],
  };
  chartRef: any[] = [];
  templeName = 'Accessibility';

  amenitiesJson: any = {
    type: 'bar',
    data : {
      labels: ['Akshardham Temple', 'Total Visitors', 'Avg. Visitor Per Day', 'Total Security'],
      datasets: [{
        label: '',
        barThickness: 20,
        data: [1.4, 2.5, 4, 2],
        backgroundColor: 'blue',
        borderColor: 'blue',
        borderWidth: 1
      }]
    }
  };
  imageClick = false;

  constructor(private chartService: ChartService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {

  }
  imageClickHandler(e: any): void {
    this.imageClick = true;
  }

  lbBox(e: any): void {
    this.imageClick = false;
  }
  seeMore(): void {
    const dots: any = document.getElementById('dots');
    const moreText: any = document.getElementById('more');
    const btnText: any = document.getElementById('myBtn');

    if (dots.style.display === 'none') {
      dots.style.display = 'inline';
      btnText.innerHTML = 'Read more';
      moreText.style.display = 'none';
    } else {
      dots.style.display = 'none';
      btnText.innerHTML = 'Read less';
      moreText.style.display = 'inline';
    }
  }

  ngAfterViewInit(): void {
  }

  destroy(): void {
    this.chartRef.forEach(el => {
      el.destroy();
    });
  }

isUrl(url: any): boolean {
  const regexp =
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  return regexp.test(url);
}

async getBase64ImageFromUrll(imageUrl: any): Promise<any> {

  const isUrl = this.isUrl(imageUrl);

  if (isUrl){
    const res = await fetch(imageUrl + '?stopGivingMeHeadaches=true');
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
      const reader  = new FileReader();
      reader.addEventListener('load', () => {
          resolve(reader.result?.toString());
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    });
}

}

  downloadZip(): void {
    const zip = new JSZip();
    const pdf = zip.folder('images');
    this.allImageData.forEach(async (iterator: any, i: any) => {
     await this.getBase64ImageFromUrll(iterator.image).then((res: any) => {

      const data = iterator.image.split('.');
      const splitForDocNme = iterator.image.split('/');
      const docName = splitForDocNme[splitForDocNme.length - 1];
      const lastInd = data[data.length - 1];
      const imgData = res.toString().split(',');
      pdf?.file(docName, imgData[1], { base64: true });
      });
    });
    setTimeout(() => {
      zip.generateAsync({type: 'blob'})
      .then((content: any) => {
          saveAs(content, 'allImages.zip');
      });
    }, 900);
  }

}
